import api from '.';

export const CONJUNTO_BUSQUEDAS_ENDPOINT = '/conjunto-busquedas';
export const CONJUNTO_BUSQUEDAS_KVP_ENDPOINT = `${CONJUNTO_BUSQUEDAS_ENDPOINT}/kvp`;

export const getAllConjuntoBusquedas = async (params) => {
    const response = await api.get(CONJUNTO_BUSQUEDAS_ENDPOINT, { params });
    return response;
};

export const getConjuntoBusquedaById = async (id) => {
    const response = await api.get(`${CONJUNTO_BUSQUEDAS_ENDPOINT}/${id}`);
    return response;
};

export const createConjuntoBusqueda = async (params) => {
    const response = await api.post(CONJUNTO_BUSQUEDAS_ENDPOINT, params);
    return response;
};

export const updateConjuntoBusqueda = async (params) => {
    const response = await api.put(CONJUNTO_BUSQUEDAS_ENDPOINT, params);
    return response;
};

export const deleteConjuntoBusqueda = async (id) => {
    const response = await api.delete(`${CONJUNTO_BUSQUEDAS_ENDPOINT}/${id}`);
    return response;
};

export const getAllConjuntoBusquedasAsKvpList = async () => {
    const response = await api.get(CONJUNTO_BUSQUEDAS_KVP_ENDPOINT);
    return response;
};
